import React, { ReactNode } from 'react';
import { IS_CORDOVA, URL_BASE_VOALA } from 'constants/constants';
import { CordovaUtils } from 'utils/CordovaUtils';
import { Link } from 'react-router-dom';

type Props = {
  to: string;
  target?: Target;
  children?: ReactNode;
  className?: string;
};

type Target = '_self' | '_blank' | '_system';

/* eslint-disable jsx-a11y/anchor-is-valid */

const OpenLink: React.FC<Props> = props => {
  const { to, target, className = 'text-color-orange', children } = props;

  function checkIsRouteInternal(): JSX.Element {
    if (to && (to.includes(`${URL_BASE_VOALA}/`) || to.charAt(0) === '/')) {
      return <Link to={to.replace(URL_BASE_VOALA, '')}>{children}</Link>;
    }
    return (
      <a
        className={`${className} link`}
        onClick={() => CordovaUtils.openLink(to, target)}
      >
        {children}
      </a>
    );
  }

  return (
    <>
      {IS_CORDOVA ? (
        checkIsRouteInternal()
      ) : (
        <a
          className={`${className} link`}
          target={target || '_blank'}
          href={to}
          rel="noopener noreferrer"
        >
          {children}
        </a>
      )}
    </>
  );
};

export default React.memo(OpenLink);
